
import { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";

const AdminAuthContext = createContext({
  isAdminLoggedIn: false,
  adminUser: null,
  adminLogin: async () => {},
  adminLogout: async () => {},
  checkAdminAuth: async () => {},
});

export const AdminAuthProvider = ({ children }) => {
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("adminAccessToken");
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setIsAdminLoggedIn(true);
    }
    setIsCheckingAuth(false);
  }, []);


  const checkAdminAuth = () => {
    const token = localStorage.getItem("adminAccessToken");
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setIsAdminLoggedIn(true);
      setAdminUser({}); 
      return { logged_in: true };
    } else {
      setIsAdminLoggedIn(false);
      setAdminUser(null);
      return { logged_in: false };
    }
  };

  const adminLogin = async (email, password) => {
    try {
      console.log("[AdminAuth] Trying login...");
      const res = await axios.post('/api/admin/token-login/', { email, password });
      console.log("[AdminAuth] Login success:", res.data);
  
      const { access, refresh, user } = res.data;
      localStorage.setItem("adminAccessToken", access);
      console.log("[AdminAuth] Token stored:", access);
  
      axios.defaults.headers.common['Authorization'] = `Bearer ${access}`;
      setIsAdminLoggedIn(true);
      setAdminUser(user);
      return res.data;
    } catch (err) {
      console.error("[AdminAuth] Login failed:", err.response || err.message);
      throw err;
    }
  };

  const adminLogout = () => {
    localStorage.removeItem("adminAccessToken");
    delete axios.defaults.headers.common['Authorization'];
    setIsAdminLoggedIn(false);
    setAdminUser(null);
  };

  const value = {
    isAdminLoggedIn,
    adminUser,
    adminLogin,
    adminLogout,
    checkAdminAuth,
    isCheckingAuth,
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
